<template>
  <div class="products">
    <h2 class="main-cl product-title">{{ $t('homeTemplate.products.text_1') }}</h2>
    <p class="gray-cl product-des">{{ $t('homeTemplate.products.text_2') }}</p>
    <div class="product-list">
      <div v-for="(item, index) in productList" :key="index">
        <div
          class="item-product-disabled"
          v-if="item.isDisabled"
          :class="userSkin === '1' ? 'dark-second-bg' : 'white-bg'"
          @mouseenter="mouseenterItem(item)"
          @mouseleave="mouseleaveItem(item)">
          <div class="item-product-title main-cl">{{ item.title }}</div>
          <div class="item-product-des">{{ item.des }}</div>
          <div class="item-next">
            <svg-icon iconClass="circle-arrow" className="icon-36 blue-10-cl"></svg-icon>
            <span></span>
          </div>
          <div class="item-icon">
            <img :src="item.icon" alt="" :style="{width: item.iconWidth, height: item.iconHeight}">
          </div>
        </div>
        <div
          class="item-product"
          v-else
          :class="userSkin === '1' ? 'dark-second-bg' : 'white-bg'"
          @mouseenter="mouseenterItem(item)"
          @mouseleave="mouseleaveItem(item)">
          <div class="item-product-title main-cl">{{ item.title }}</div>
          <div class="item-product-des">{{ item.des }}</div>
          <div class="item-next" :class="item.isHover ? 'blue-10-bg' : ''" @click="btnClick(item.linkUrl)">
            <span class="blue-cl">{{ item.isHover ? $t('homeTemplate.products.text_9') : '' }}</span>
            <svg-icon iconClass="circle-arrow-color" className="icon-36 blue-cl"></svg-icon>
            <span v-if="!item.isHover"></span>
          </div>
          <div class="item-icon">
            <img :src="item.icon" alt="" :style="{width: item.iconWidth, height: item.iconHeight}">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import derivatives from '@/assets/img/derivatives.png';
import spotTrading from '@/assets/img/spot_trading.png';
import buyCrypto from '@/assets/img/buy_crypto.png';

export default {
  data() {
    return {
      productList: [
        {
          title: this.$t('homeTemplate.products.text_3'),
          des: this.$t('homeTemplate.products.text_4'),
          icon: derivatives,
          iconWidth: '155px',
          iconHeight: '160px',
          isHover: false,
          isDisabled: false,
          linkUrl: '/futures',
        },
        {
          title: this.$t('homeTemplate.products.text_5'),
          des: this.$t('homeTemplate.products.text_6'),
          icon: spotTrading,
          iconWidth: '134px',
          iconHeight: '180px',
          isHover: false,
          isDisabled: false,
          linkUrl: '/trade',
        },
        {
          title: this.$t('homeTemplate.products.text_7'),
          des: this.$t('homeTemplate.products.text_8'),
          icon: buyCrypto,
          iconWidth: '170px',
          iconHeight: '140px',
          isHover: false,
          isDisabled: false,
          linkUrl: '/otc',
        },
      ],
    };
  },
  computed: {
    // 用户选择的skin
    userSkin() {
      return getCookie('cusSkin') || getCookie('defSkin')
    },
  },
  methods: {
    mouseenterItem(item) {
      item.isHover = true;
    },
    mouseleaveItem(item) {
      item.isHover = false;
    },
    btnClick(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang='scss' scoped>
  .products {
    margin-top: 100px;
  }
  .product-title {
    font-size: 36px;
    line-height: 58px;
    margin-bottom: 8px;
    font-weight: 600;
  }
  .product-des {
    font-size: 16px;
    letter-spacing: 0.01em;
    margin-bottom: 48px;
  }
  .product-list {
    display: flex;
    justify-content: space-between;
    .item-product, .item-product-disabled {
      padding: 40px;
      box-sizing: border-box;
      width: 378px;
      height: 540px;
      box-shadow: 1px 1px 14px rgba(0, 0, 0, 0.1);
      border-radius: 16px;
      cursor: pointer;
      transition: all 0.3s;
      .item-product-title {
        font-weight: 600;
        font-size: 30px;
        line-height: 48px;
        margin-bottom: 16px;
      }
      .item-product-des {
        font-weight: 500;
        font-size: 20px;
        line-height: 32px;
        margin-bottom: 44px;
        min-height: 100px;
      }
      .item-next {
        width: 52px;
        height: 52px;
        margin-bottom: 18px;
        border-radius: 38px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: width 0.3s ease-in-out;
        box-sizing: border-box;
        span {
          opacity: 0;
          font-size: 20px;
          transition: opacity 0.3s ease-in 0.31s;
        }
        // margin-bottom: 36px;
      }
      // .item-hover {
      //   width: 192px;
      //   span {
      //     opacity: 1;
      //     font-size: 20px;
      //   }
      // }
      .item-icon {
        height: 180px;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        transition: all 0.3s linear;
      }
      .item-arrow-box {
        width: 36px;
        height: 36px;
        position: relative;
      }
      .item-arrow-bg {
        width: 36px;
        height: 36px;
        border-radius: 36px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .item-arrow-icon {
        z-index: 2;
      }
    }
    .item-product:hover {
      box-shadow: 0px 2px 32px rgba(24,32,82,0.2);
      .item-next {
        width: 192px;
        padding: 0 8px 0 24px;
        box-sizing: border-box;
        span {
          opacity: 1;
        }
      }
      .item-icon {
        transform: scale(1.1);
      }
    }
    .item-product-disabled:hover {
      box-shadow: 0px 2px 32px rgba(24,32,82,0.2);
      .item-icon {
        transform: scale(1.1);
      }
    }
  }
</style>
